<template>
    <div class="product-list-wrapper">
        <div id="search_advanced" class="collapse">
            <div class="card panel panel-default ks-solid mt-0 mb-5">
                <div class="card-block">
                    <advanced-search @handleAdvancedSearchSubmit="advancedSearchHandler"
                        @searchQueryUpdate="handleAdvancedSearchUpdate"
                        @alert="handleAlert"
                        :simple-search="simpleSearch"
                        :project-id="projectId"
                        :search-id="searchId"
                        :user-id="userId"
                        :search-name="searchName"
                        :search-desc="searchDesc"
                        :is-new-project="isNewProject"
                        ref="advancedSearch"
                    ></advanced-search>
                </div>
            </div>
        </div>

        <div class="row pl-3 pb-1">
            <div class="col-md-1">
                <div v-if="canManageProducts" class="dropdown">
                    <i class="fa fa-plus multi-select-dropdown" aria-hidden="true" @click="handleSelectDropdownClick"></i>
                    <div class="dropdown-menu" id="select-dropdown">
                        <span class="dropdown-item" @click="handleSelectAll" v-if="!isAllSelected">
                            <span class="item-copy">Select All</span>
                        </span>
                        <span class="dropdown-item" @click="handleSelectNone" v-if="isAllSelected || (selectedCount > 0 || selectedCount === 'all')">
                            <span class="item-copy">Select None</span>
                        </span>
                        <span class="dropdown-item" @click="handleSelectVisible" v-if="!isAllSelected">
                            <span class="item-copy">Select Visible</span>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-md-3">Product Name</div>
            <div class="col-md-2"></div>
            <div class="col-md-2 pl-3">SKU</div>
            <div class="col-md-2">Brand</div>
            <div class="col-md-1">Visibility</div>
            <div class="col-md-1"></div>
        </div>
        <div class="row product-row-background" v-for="product in productList" :key="product.id">
            <div class="col-md-1 d-flex justify-content-between align-items-center" >
                <div v-if="canManageProducts">
                    <input type="checkbox" class="product-select-checkbox" v-model="product.isChecked" @change="handleCheckboxChangeOnProduct(product)">
                </div>
                <div class="ml-2" v-if="product.thumbnail !== null" @click="showImage(product)" @mouseover="handleProductImageHover('over', product.id)" @mouseleave="handleProductImageHover('leave', product.id)">
                    <img class="product-thumbnail" :class="{'thumbnail-fade': productImageHover === product.id}" :src="product.thumbnail" alt="">
                    <i v-if="product.id == productImageHover" class="la la-search search-icon"></i>
                </div>
            </div>
            <div class="col-md-3"><a :href="getEditLinkForProduct(product.id)">{{product.name}}</a><br><span class="small-text">ID: {{product.id}}</span></div>
            <div class="col-md-2" v-if="product.isChild">Variant of PIM Id {{product.parentId}}</div>
            <div class="col-md-2" v-else-if="product.isParent">Parent</div>
            <div class="col-md-2" v-else></div>
            <div class="col-md-2 product-sku" :data-sku="product.sku">
                <div :style="{ overflow: currentActiveSKU === product.sku ? 'unset' : 'hidden' }">
                    <button class="sku-btn btn p-0 d-flex justify-content-start font-weight-normal" style="color: #333; background: transparent;" @click="copySKUToClipboard(product.sku)" @mouseover="(currentActiveSKU = product.sku)" @mouseleave="(currentActiveSKU = '')">
                        <span v-if="(currentActiveSKU === product.sku)" class="position-absolute" style="color: #333;">
                            <i class="fa fa-copy"></i>
                        </span>
                        <span class="pl-0 ml-3" :class="{ 'sku-hovered': currentActiveSKU === product.sku }">
                            {{ product.sku }}
                        </span>
                    </button>
                </div>
            </div>
            <div class="col-md-2">{{product.brand}}</div>
            <div class="col-md-1">
                <i v-if="product.visible" class="pl-3 fa fa-eye eye-big green"></i>
                <i v-else class="pl-3 fa fa-eye-slash eye-big red"></i>
            </div>
            <div class="col-md-1"><a class="btn btn-outline-primary" role="button" :href="getEditLinkForProduct(product.id)">View</a></div>
        </div>
        <div class="d-flex justify-content-between pt-2 pb-5">
            <select name="select-per-page" @change="handlePerPageChange" v-model="pageSize" class="form-control border-radius py-0 px-1 max-w-xs">
                <option v-for="(amount, index) in amountsShown" :key="index" :value="amount.value">{{amount.text}}</option>
            </select>
            <div class="text-right">
                <paginator v-show="paginationData.last_page > 1" :showFirstLast="true" :pagination="paginationData" @paginate="handlePageChange"></paginator>
                <div>{{showing}}</div>
            </div>
        </div>
        <!-- Modal -->
        <div class="modal fade" id="productImage" tabindex="-1" role="dialog" aria-labelledby="product image large" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-body text-center">
                        <img class="image-preview" :src="enlargePhoto" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="load-indicator" v-show="showGeneralLoadIndicator">
            <!-- <span class="fa fa-cog fa-spin fa-1x"></span> -->
        </div>
        <product-alerts :status="alert" v-model="alert"></product-alerts>
    </div>
</template>

<script>
// TODO: REFACTOR!
import axios from "axios";
import AdvancedSearch from "./advanced-search/advanced-search.vue";
import TablePagination from "../generic/tables/pagination.vue";
import ProductAlerts from './product-details-alerts.vue';

const base_url = window.location.protocol + "//" + window.location.host;

export default {
    name: "product-list",
    components: {
        "advanced-search": AdvancedSearch,
        paginator: TablePagination,
        'product-alerts': ProductAlerts
    },
    data() {
        return {
            skuModalOpen: false,
            currentActiveSKU: '',
            advancedSearchQuery: "",
            simpleSearch: "",
            showGeneralLoadIndicator: false,
            productImageHover: -1,
            enlargePhoto: null,
            totalProducts: 0,
            filterProducts: 0,
            from: 0,
            pageSize: 25,
            currentPage: 1,
            productList: [],
            isAllSelected: false,
            selectedCount: 0,
            alert: {
                message: "",
                status: "",
                timeOut: 15000,
            },
            amountsShown: [
                { text: "Products Per Page: 10", value: 10 },
                { text: "Products Per Page: 25", value: 25 },
                { text: "Products Per Page: 50", value: 50 },
                { text: "Products Per Page: 100", value: 100 }
            ]
        };
    },
    props: {
        canManageProducts: {
            type: Boolean,
            default: false
        },
        projectId: {
            type: [Number, String]
        },
        searchId: {
            type: [String, Number]
        },
        searchName: {
            type: [String]
        },
        searchDesc: {
            type: [String]
        },
        userId: {
            type: [Number, String]
        }
    },
    mounted() {
        //NOTE: the initial product load is triggered from the advanced-search component.
        $("#search_string").on("keypress", event => {
            let code = event.which;
            if (code == 13) {
                //Enter keycode
                this.from = 0;
                this.currentPage = 1;
                this.handleSimpleSearchQueryUpdate();
            }
        });

        this.updateProductSelectedCount();
    },
    computed: {
        isNewProject() {
            let urlParams = (new URL(document.location)).searchParams;
            return !!urlParams.get('new');
        },
        sessionSelectedAll() {
            let currentSessionSelected = window.sessionStorage.getItem(
                "products.selected"
            );

            return currentSessionSelected === "all";
        },
        sessionSelected() {
            let currentSessionSelected = window.sessionStorage.getItem(
                "products.selected"
            );

            if (currentSessionSelected.length) {
                return currentSessionSelected === "all"
                    ? "all"
                    : JSON.parse(currentSessionSelected);
            }

            return null;
        },
        sessionExcluded() {
            let currentSessionExcluded = window.sessionStorage.getItem(
                "products.excluded"
            );

            return currentSessionExcluded.length
                ? JSON.parse(currentSessionExcluded)
                : null;
        },
        paginationData() {
            return {
                current_page: this.currentPage,
                last_page: Math.ceil(this.filterProducts / this.pageSize),
                to: true
            };
        },
        showing() {
            let more = this.filterProducts >= 1000 ? "+" : "";
            let selected,
                result = "";

            if (this.selectedCount > 0) {
                selected = ` - ${this.selectedCount} selected`;
            } else if (this.selectedCount < 0) {
                selected = "";
            }

            if (this.isAllSelected === true) {
                let currentSessionExcluded = window.sessionStorage.getItem(
                    "products.excluded"
                );
                let currentSessionSelected = window.sessionStorage.getItem(
                    "products.selected"
                );

                if (
                    currentSessionSelected === "all" &&
                    currentSessionExcluded == null
                ) {
                    // if truly "all" are selected
                    result = `All products selected`;
                } else if (currentSessionExcluded != null) {
                    // if "all" are selected but some are excluded

                    let excludedCount = JSON.parse(currentSessionExcluded);

                    result = `${this.filterProducts}${more} results - ${this
                        .filterProducts - excludedCount.length} selected`;
                }
            } else {
                if (typeof selected !== 'undefined') {
                    result = `${this.filterProducts}${more} results${selected}`;
                } else {
                    result = `${this.filterProducts}${more} results`;
                }
            }

            return result;
        }
    },
    methods: {
        async copySKUToClipboard(sku) {
            try {
                await navigator.clipboard.writeText(sku);
                this.handleAlert({ message: 'Copied to clipboard', status: 'alert-success' });
            } catch (err) {
                console.error('Failed to copy: ', err);
            }
        },
        handleAdvancedSearchUpdate(updatedQuery) {
            this.advancedSearchQuery = updatedQuery;
        },
        handleAlert(alert) {
            this.alert.message = alert.message;
            this.alert.status = alert.status;

            this.fetchProductList();
        },
        handleSelectDropdownClick() {
            $("#select-dropdown").show();
        },
        showImage(product) {
            this.enlargePhoto = product.thumbnail;
            $("#productImage").modal("toggle");
        },
        handleProductImageHover(state, id) {
            if (state == "leave") {
                this.productImageHover = -1;
            } else {
                this.productImageHover = id;
            }
        },
        updateProductSelectedCount(type) {
            let currentSessionSelected = window.sessionStorage.getItem(
                "products.selected"
            );

            let currentSessionExcluded = window.sessionStorage.getItem(
                "products.excluded"
            );

            if (currentSessionSelected != null) {
                if (
                    currentSessionSelected === "all" &&
                    currentSessionExcluded == null
                ) {
                    this.selectedCount = "all";
                } else if (
                    currentSessionSelected === "all" &&
                    currentSessionExcluded.length
                ) {
                    currentSessionExcluded = JSON.parse(currentSessionExcluded);

                    let excludedCount = currentSessionExcluded.length;

                    this.selectedCount = this.filterProducts - excludedCount;
                } else {
                    let parsed = JSON.parse(currentSessionSelected);
                    this.selectedCount = parsed.length;
                }
            }

            //the global selectedrecords variable is used by the bulk jquery component
            window.selectedrecords = this.selectedCount;
        },
        getEditLinkForProduct(id) {
            //products/1/edit/v2
            return base_url + "/products/" + id + "/edit/v2";
        },
        handlePerPageChange() {
            this.from = 0;
            this.currentPage = 1;
            this.fetchProductList();
        },
        handlePageChange(page) {
            this.currentPage = page;
            this.from = this.pageSize * (page - 1);
            this.fetchProductList();
        },
        handleCheckboxChangeOnProduct(product) {
            this.showGeneralLoadIndicator = true;

            let id = product.id;
            let action = product.isChecked ? "select" : "unselect";
            let currentSessionSelected, currentSessionExcluded;

            currentSessionSelected = window.sessionStorage.getItem(
                "products.selected"
            );
            currentSessionExcluded = window.sessionStorage.getItem(
                "products.excluded"
            );

            if (action === "select") {
                if (this.selectedCount >= 1000) {
                    // "client-side validation" if too many selected at once
                    alert("No more than 1000 records may be selected at once");
                } else if (currentSessionSelected == null) {
                    // if no products have been selected yet
                    currentSessionSelected = [];
                    currentSessionSelected.push(id);

                    window.sessionStorage.setItem(
                        "products.selected",
                        JSON.stringify(currentSessionSelected)
                    );

                    this.updateProductSelectedCount();
                } else if (currentSessionSelected === "all") {
                    // if "all" is enabled but we wish to remove an item from products.excluded
                    if (currentSessionExcluded.length > 0) {
                        let excludedParsed = JSON.parse(currentSessionExcluded);

                        if (excludedParsed.includes(id)) {
                            let index = excludedParsed.indexOf(id);

                            excludedParsed.splice(index, 1);

                            // remove any potential duplicates
                            currentSessionExcluded = [
                                ...new Set(excludedParsed)
                            ];

                            window.sessionStorage.setItem(
                                "products.excluded",
                                JSON.stringify(currentSessionExcluded)
                            );
                        }
                    }
                } else {
                    // if "all" is selected we can use the presence of
                    // the "products.excluded" session object to determine
                    // what is/isnt selected server-side

                    currentSessionSelected = JSON.parse(currentSessionSelected);
                    currentSessionSelected.push(id);

                    // remove any potential duplicates
                    currentSessionSelected = [
                        ...new Set(currentSessionSelected)
                    ];

                    window.sessionStorage.setItem(
                        "products.selected",
                        JSON.stringify(currentSessionSelected)
                    );

                    this.updateProductSelectedCount();
                }
            } else {
                // unselect current product if "all" enabled
                if (currentSessionSelected === "all") {
                    currentSessionExcluded = JSON.parse(
                        window.sessionStorage.getItem("products.excluded")
                    );

                    // if products.excluded doesn't yet exist in sessionStorage
                    if (currentSessionExcluded == null) {
                        currentSessionExcluded = [];
                    }

                    currentSessionExcluded.push(id);
                    currentSessionExcluded = [
                        ...new Set(currentSessionExcluded)
                    ];

                    window.sessionStorage.setItem(
                        "products.excluded",
                        JSON.stringify(currentSessionExcluded)
                    );

                    this.updateProductSelectedCount();
                } else {
                    // if 'all' isn't enabled, remove from products.selected
                    currentSessionSelected = JSON.parse(currentSessionSelected);

                    if (currentSessionSelected.includes(id)) {
                        let index = currentSessionSelected.indexOf(id);

                        currentSessionSelected.splice(index, 1);

                        // remove any potential duplicates
                        currentSessionSelected = [
                            ...new Set(currentSessionSelected)
                        ];

                        this.updateProductSelectedCount();

                        window.sessionStorage.setItem(
                            "products.selected",
                            JSON.stringify(currentSessionSelected)
                        );
                    }
                }
            }

            axios
                .post(base_url + "/products/" + id + "/" + action, {})
                .then(response => {
                    this.updateProductSelectedCount();
                    this.showGeneralLoadIndicator = false;
                })
                .catch(error => {
                    console.log(action + " " + id + " error:", error);
                    this.showGeneralLoadIndicator = false;
                });
        },
        handleSelectAll() {
            $("#select-dropdown").hide();
            this.showGeneralLoadIndicator = true;

            this.productList.forEach(product => {
                product.isChecked = true;
            });

            window.sessionStorage.setItem("products.selected", "all");
            window.sessionStorage.removeItem("products.excluded");

            axios
                .post(base_url + "/products/select/all", {})
                .then(response => {
                    this.updateProductSelectedCount("all");
                    this.isAllSelected = true;
                    this.showGeneralLoadIndicator = false;
                })
                .catch(error => {
                    console.log("select all error:", error);
                    this.showGeneralLoadIndicator = false;
                });
        },
        handleSelectNone() {
            $("#select-dropdown").hide();
            this.showGeneralLoadIndicator = true;
            this.productList.forEach(product => {
                product.isChecked = false;
            });

            window.sessionStorage.removeItem("products.selected");
            window.sessionStorage.removeItem("products.excluded");
            window.sessionStorage.setItem(
                "products.selected",
                JSON.stringify([])
            );

            axios
                .post(base_url + "/products/select/none", {})
                .then(response => {
                    this.updateProductSelectedCount();
                    window.selectedrecords = 0;
                    this.isAllSelected = false;
                    this.showGeneralLoadIndicator = false;
                })
                .catch(error => {
                    this.showGeneralLoadIndicator = false;
                    console.log("select none error:", error);
                });
        },
        handleSelectVisible() {
            $("#select-dropdown").hide();
            this.showGeneralLoadIndicator = true;
            let selectedIds = [];
            this.productList.forEach(product => {
                product.isChecked = true;
                selectedIds.push(product.id);
            });

            window.sessionStorage.setItem(
                "products.selected",
                JSON.stringify(selectedIds)
            );

            //need to get an array of selected products (by id) and pass it to the backend
            axios
                .post(base_url + "/products/select/visible", {
                    ids: selectedIds
                })
                .then(response => {
                    this.showGeneralLoadIndicator = false;
                    this.updateProductSelectedCount();
                })
                .catch(error => {
                    this.showGeneralLoadIndicator = false;
                    console.log("select visible error:", error);
                });
        },
        styleForThumb(uri) {
            return {
                "background-image": uri
            };
        },
        advancedSearchHandler() {
            this.from = 0;
            this.currentPage = 1;
            this.fetchProductList();
        },
        handleSimpleSearchQueryUpdate() {
            //lets the advanced-search component know that a new simple search term has been added
            this.simpleSearch = $("#search_string").val();
        },
        fetchProductList() {
            this.showGeneralLoadIndicator = true;

            if (
                (this.advancedSearchQuery != "" &&
                JSON.parse(this.advancedSearchQuery).constraints.length > 0) || this.isNewProject
            ) {
                this.$nextTick(() => {
                    $("#search_advanced").collapse("show");
                    $("#advancedSearchButton").css({ color: "#ab5755" });
                });
            } else {
                $("#advancedSearchButton").css({ color: "rgb(29, 76, 111)" });
            }

            let endPoint =
                "/pimapi/products/search?size=" +
                this.pageSize +
                "&from=" +
                this.from +
                "&q=" +
                encodeURIComponent($("#search_string").val());

            if (this.advancedSearchQuery !== "") {
                endPoint =
                    "/pimapi/products/search?size=" +
                    this.pageSize +
                    "&q=" +
                    encodeURIComponent(
                        JSON.parse(this.advancedSearchQuery).simpleSearch
                    ) +
                    "&f=" +
                    encodeURIComponent(this.advancedSearchQuery) +
                    "&from=" +
                    this.from;
            }

            let currentSessionSelected = window.sessionStorage.getItem(
                "products.selected"
            );

            let currentSessionExcluded = window.sessionStorage.getItem(
                "products.excluded"
            );

            if (currentSessionSelected === "all") {
                this.isAllSelected = true;
            }

            axios
                .get(base_url + endPoint, {})
                .then(response => {
                    this.productList = response.data.data.map(product => {
                        let isChecked;

                        if (currentSessionSelected === "all") {
                            if (currentSessionExcluded != null) {
                                currentSessionExcluded = JSON.parse(
                                    window.sessionStorage.getItem(
                                        "products.excluded"
                                    )
                                );

                                isChecked = currentSessionExcluded.includes(
                                    product.id
                                )
                                    ? false
                                    : true;
                            } else {
                                isChecked = true;
                            }
                        } else {
                            isChecked =
                                currentSessionSelected == null
                                    ? false
                                    : JSON.parse(
                                          window.sessionStorage.getItem(
                                              "products.selected"
                                          )
                                      ).includes(product.id);
                        }


                        return {
                            id: product.id,
                            isChecked: isChecked,
                            thumbnail: product.thumbnailuri,
                            name: product.name,
                            sku: product.sku,
                            brand: product.brand,
                            visible: product.is_visible,
                            isParent: product.is_parent,
                            isChild: product.is_child,
                            parentId: product.parent_id
                        };



                    });

                    // handle "all selected" state so Select All/None/Visible dropdown works as intended
                    if (currentSessionSelected === "all") {
                        this.isAllSelected = currentSessionExcluded == null;
                    }

                    this.updateProductSelectedCount();
                    this.filterProducts = response.data.recordsFiltered;
                    this.totalProducts = response.data.recordsTotal;
                    this.showGeneralLoadIndicator = false;
                })
                .catch(error => {
                    console.log("product list error:", error);
                    this.showGeneralLoadIndicator = false;
                });
        }
    }
};
</script>

<style lang="scss">
.product-list-wrapper {
    .product-row-background {
        background-color: white;
        border: 1px solid #d6d9da;
        border-radius: 5px;
        padding: 0px;
        margin: 0px 0px 4px 0px;
        height: 75px;
        display: flex;
        align-items: center;
    }

    .product-sku {
        position: relative;
    }

    .sku-hovered {
        background: #ffffffdd;
        z-index: 1;
        padding-right: 1rem;
    }

    .sku-full {
        z-index: 10;
        position: absolute;
        top: -0.25rem;
        left: -1rem;
        box-shadow: 1px 1px 4px rgb(0 0 0 / 25%);
        padding: 0.15rem;
        background: white;
        border-radius: 6px;
        min-width: 14rem;
    }

    .product-select-checkbox {
        -webkit-appearance: none;
        background-color: white;
        border: 1px solid #cacece;
        padding: 9px;
        border-radius: 3px;
        display: inline-block;
        position: relative;
    }

    .product-select-checkbox:checked {
        background-color: white;
        border: 1px solid #adb8c0;
        color: #3a6890;
    }

    .product-select-checkbox:checked:after {
        content: "\2713";
        font-size: 14px;
        position: absolute;
        top: 0px;
        left: 4px;
        color: #3a6890;
    }
    .eye-big {
        font-size: 18px;
    }

    .green {
        color: #339c8d;
    }

    .red {
        color: #994343;
    }
    .small-text {
        font-size: 11px;
    }

    .product-thumbnail {
        display: block;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        overflow: hidden;
        border: 1px solid #dedede;
        object-fit: cover;
    }

    .thumbnail-fade {
        opacity: 0.25;
    }

    .search-icon {
        position: absolute;
        font-size: 20px;
        top: 18px;
        right: 32px;
    }

    .image-preview {
        max-width: 450px;
        height: auto;
        width: auto;
    }

    .multi-select-dropdown {
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 25px;
        height: 25px;
        border: 1px solid #dedede;
        background-color: white;
        cursor: pointer;
        font-size: 10px;
    }
}
</style>
